<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page018">
<div class="jstfy" id="page018_1">APRICOT CROISSANTS</div>
<div class="jstfy" id="page018_2">C<span class="small1">roissants à l</span>’A<span class="small1">bricot</span></div>
<div class="jstfy" id="page018_3">TIME REQUIRED:</div>
<div class="jstfy" id="page018_4">C<span class="small">roissants are said</span> to be named after the crescent moon, which</div>
<div class="jstfy" id="page018_5">25 minutes</div>
<div class="jstfy" id="page018_6">they resemble. Although they’re time-consuming to make, you’ll</div>
<div class="jstfy" id="page018_7">be rewarded by their incomparably soft and flaky texture.</div>
<div class="jstfy" id="page018_8">+ about 12 hours cooling</div>
<div class="jstfy" id="page018_9">and resting time</div>
<div class="jstfy" id="page018_10">1.</div>
<div class="jstfy" id="page018_10a"><span class="page018_10a"> Combine the milk and water in a bowl. Mix the flour, salt,</span></div>
<div class="jstfy" id="page018_11">sugar and yeast separately and add to the mixture. Finally, add</div>
<div class="jstfy" id="page018_12">Makes 8</div>
<div class="jstfy" id="page018_13">the melted margarine. Knead briefly with a mixer fitted with</div>
<div class="jstfy" id="page018_14">500 g vegan leavened</div>
<div class="jstfy" id="page018_15">a dough hook on low speed for about 1 minute (add a little</div>
<div class="jstfy" id="page018_16">laminated (croissant or</div>
<div class="jstfy" id="page018_17">water or flour if necessary). Roll the dough into a ball, transfer</div>
<div class="jstfy" id="page018_18">Danish pastry) dough</div>
<div class="jstfy" id="page018_19">to a bowl greased with oil and rest for at least 6 hours in the</div>
<div class="jstfy" id="page018_20">8 tbsp apricot jam</div>
<div class="jstfy" id="page018_21">refrigerator.</div>
<div class="jstfy" id="page018_22">2.</div>
<div class="jstfy" id="page018_22a"><span class="page018_22a">Next, cut the cold margarine into small pieces and knead</span></div>
<div class="jstfy" id="page018_23">Vegan cream, for glazing</div>
<div class="jstfy" id="page018_24">with a teaspoon of flour. Work quickly to prevent the margarine</div>
<div class="jstfy" id="page018_25">becoming too soft. Put the margarine on a sheet of aluminium</div>
<div class="jstfy" id="page018_26">For the dough:</div>
<div class="jstfy" id="page018_27">foil and shape into a 15-cm square about 5 mm in thickness.</div>
<div class="jstfy" id="page018_28">225 g flour</div>
<div class="jstfy" id="page018_29">Wrap it in foil and rest in the refrigerator for 1 hour.</div>
<div class="jstfy" id="page018_30">1 pinch salt</div>
<div class="jstfy" id="page018_31">3.</div>
<div class="jstfy" id="page018_31a"><span class="page018_31a">Roll out the dough on a floured work surface into roughly 30 x</span></div>
<div class="jstfy" id="page018_32">20 g sugar</div>
<div class="jstfy" id="page018_33">20-cm rectangle. Lay the margarine square on the left side of the</div>
<div class="jstfy" id="page018_34">½ sachet dry yeast</div>
<div class="jstfy" id="page018_35">dough and fold the right side over to encase it. Seal the edges well.</div>
<div class="jstfy" id="page018_36">75 ml soya milk</div>
<div class="jstfy" id="page018_37">Use a rolling pin to carefully roll out the dough into a 40 x 20-cm</div>
<div class="jstfy" id="page018_38">80 ml cold water</div>
<div class="jstfy" id="page018_39">sheet. Fold the right and left edges over into the middle and rest</div>
<div class="jstfy" id="page018_40">10 g high-quality vegan</div>
<div class="jstfy" id="page018_41">in the refrigerator for about 30 minutes.</div>
<div class="jstfy" id="page018_42">margarine, melted</div>
<div class="jstfy" id="page018_43">4.</div>
<div class="jstfy" id="page018_43a"><span class="page018_43a">Place the dough on a floured work surface. Carefully roll it out</span></div>
<div class="jstfy" id="page018_44">again to a 40 x 20-cm sheet then fold it into thirds. Rest in the</div>
<div class="jstfy" id="page018_45">125 g high-quality vegan</div>
<div class="jstfy" id="page018_46">refrigerator for 30 minutes and then repeat the operation. Then</div>
<div class="jstfy" id="page018_47">margarine, cold</div>
<div class="jstfy" id="page018_48">refrigerate the dough for 20 more minutes.</div>
<div class="jstfy" id="page018_49">1 tsp plain flour</div>
<div class="jstfy" id="page018_50">B<span class="pagen">asics</span></div>
<div class="jstfy" id="page018_0">18</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_018.vue?31ad8098